import { render, staticRenderFns } from "./DeleteUserModal.vue?vue&type=template&id=b5e0203e&"
import script from "./DeleteUserModal.vue?vue&type=script&lang=ts&"
export * from "./DeleteUserModal.vue?vue&type=script&lang=ts&"
import style0 from "./DeleteUserModal.vue?vue&type=style&index=0&id=b5e0203e&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports